export default function (min, max) {
  return Math.random() * (max - min) + min
}



// WEBPACK FOOTER //
// ./resources/assets/js/random.js